import { API_EMPLOYEE, API_EMPLOYEE_TREE } from "@/configs/Apis";
import { Fetcher as Ajax } from "@/utils/Request";
import cloneDeep from "lodash/cloneDeep";
import merge from "lodash/merge";
import { Module } from "vuex";
import baseModule from "./common";

const newModule: Module<any, any> = merge(cloneDeep(baseModule), {
  actions: {
    getEmployeeTree({ commit }: any) {
      return Ajax.queryData(API_EMPLOYEE_TREE, {}, "GET", false)
        .then(data => {
          let count = 0;
          function execCount(item: any) {
            if (item && item.children) {
              item.children.forEach((child: any) => {
                count += child.count;
              });
            }
          }
          if (data && data.length) {
            execCount(data[0]);
          }
          commit(
            "setEmployeeTree",
            [
              {
                title: "全部",
                count: count,
                icon: "all-data",
                employeeFilter: {}
              }
            ].concat(data[0].children)
          );
        })
        .catch(() => {
          commit("setEmployeeTree", [
            {
              title: "全部",
              count: 0,
              icon: "all-data",
              employeeFilter: {}
            }
          ]);
        });
    },
    addEmployee(store: any, payload: any) {
      return Ajax.saveData(API_EMPLOYEE, payload, "POST");
    },
    updateEmployee(store: any, payload: any) {
      return Ajax.saveData(API_EMPLOYEE + "/" + payload.id, payload, "PUT");
    },
    deleteEmployee(store: any, filter: any) {
      return Ajax.saveData(API_EMPLOYEE, filter, "DELETE");
    }
  },
  mutations: {
    setEmployeeTree(state: any, data: any) {
      state.employeeTree = data;
    }
  }
});

const oldState = newModule.state as () => Object;

newModule.state = () => ({ ...oldState(), employeeTree: null });

export default newModule;
